let mall = [
    {
      path: '/integral/detail',
      name: 'productdetail',
      component: () => import('@/views/integral/detail'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/integral/payment',
      name: 'payment',
      component: () => import('@/views/integral/payment'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/order',
      name: 'order',
      component: () => import('@/views/integral/order'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/orderInfo',
      name: 'orderInfo',
      component: () => import('@/views/integral/orderInfo'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/record',
      name: 'record',
      component: () => import('@/views/integral/record'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/assort',
      name: 'assort',
      component: () => import('@/views/integral/assort'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/growing',
      name: 'growing',
      component: () => import('@/views/integral/growing'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    }
    ,
    {
      path: '/integral/signin',
      name: 'signin',
      component: () => import('@/views/integral/signin'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
      
    }
    ,
    {
      path: '/integral/search',
      name: 'search',
      component: () => import('@/views/integral/search'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
      
    }
    ,
    {
      path: '/integral/transferpoints',
      name: 'transferpoints',
      component: () => import('@/views/integral/transferpoints'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
      
    }
    
]
export default mall


// WEBPACK FOOTER //
// ./src/router/mall.js